import { Component } from '@angular/core';
import { EntitySelectorComponent } from '@app/selection/entity-selector.component';
import { Employee } from '@app/_models/_DTOs/employee';
import { EmployeeService } from '@app/_services/employee.service';

@Component({
    selector: 'app-employee-selector',
    templateUrl: './employee-selector.component.html',
    styleUrls: ['./employee-selector.component.css']
})
export class EmployeeSelectorComponent extends EntitySelectorComponent<Employee> {


    constructor(
        private employeeService: EmployeeService
    ) {
        super(employeeService);
    }
}